export function loadApplication(url: string, callback: () => void) {
  const script = document.createElement('script');
  document.body.append(script);

  script.onload = () => callback();

  script.src = url;
}
